import React, { useState, useContext, useEffect } from "react";
import { landingPageContext } from "../LandingEdits";

interface Banner {
  id: number;
  image: any;
}

const BannerManager: React.FC = () => {
  const context = useContext(landingPageContext);
  if (!context) throw new Error("BannerManager must be used within LandingEdits");

  const { landingDetails, setLandingDetails } = context;

  const [banners, setBanners] = useState<Banner[]>(
    landingDetails.banner.map((url: string, index: number) => ({
      id: index,
      image: url,
    }))
  );

  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };
  useEffect(() => {
    console.log("banners", banners);
  }, []);

  const handleImageUpload = async (id: number, file: File) => {
    try {
      const base64 = await convertToBase64(file);
      const updated = banners.map((b) => (b.id === id ? { ...b, image: base64 } : b));
      setBanners(updated);

      const updatedUrls = updated.map((b) => b.image);
      setLandingDetails((prev) => {
        if (!prev) return prev; // or return some default object
        return {
          ...prev,
          banner: updatedUrls,
        };
      });
    } catch (error) {
      console.error("Error converting file to base64:", error);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Manage Landing Page Banners</h2>
      <p className="text-sm text-yellow-600 mb-4">
        ⚠️ Please ensure all banner images are in <strong>16:9 ratio</strong> for best display results.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {banners.map((banner) => (
          <div key={banner?.id} className="relative border rounded-xl p-4 shadow space-y-4">
            <img
              src={banner.image && typeof banner.image === "object" ? banner.image.image : banner.image}
              alt={`Banner ${banner?.id + 1}`}
              className="w-full h-40 object-cover rounded"
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) handleImageUpload(banner.id, file);
              }}
              className="w-full text-sm"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BannerManager;
